import { ButtonProps } from '@mui/material';
import { atomWithReset } from 'jotai/utils';

const pageDrawerButtonsAtom = atomWithReset<ButtonProps[]>([]);

export default pageDrawerButtonsAtom;
